/*==========================
 商品 相關功能Service

 Author : Alan
 最後更新時間 : 2016 / 02 / 25
==========================*/

window.InifECShared.factory("ProductService", ['$q', '$http', 'Upload', function($q, $http, Upload) {

    var factory = {};

    // --------------------------------
    // 取得全站商品大分類、分類（完整版）
    // --------------------------------
    var getPdtClassList = function() {

        if(factory.pdtClass["getPdtClassList"]) {
            return factory.pdtClass["getPdtClassList"].promise;
        }

        factory.pdtClass["getPdtClassList"] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ProductListAction.do",
            method: "GET",
            params: {
                op: "getPdtClassList",
            },
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.pdtClass["getPdtClassList"].reject(data.error);
            } else {
                factory.pdtClass["getPdtClassList"].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.pdtClass["getPdtClassList"].reject(data);
            console.error("[InifEC Error] : ProductService.getPdtClassList request error.");
            console.error("status : " + status);
        });

        return factory.pdtClass["getPdtClassList"].promise;
    }

    // --------------------------------
    // 取得全站商品大分類、分類（精簡版）
    // --------------------------------
    var getProductClassListLite = function() {

        if(factory.pdtClass["getProductClassListLite"]) {
            return factory.pdtClass["getProductClassListLite"].promise;
        }

        factory.pdtClass["getProductClassListLite"] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ProductListAction.do",
            method: "GET",
            params: {
                op: "getProductClassListLite",
            },
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.pdtClass["getProductClassListLite"].reject(data.error);
            } else {
                factory.pdtClass["getProductClassListLite"].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.pdtClass["getProductClassListLite"].reject(data);
            console.error("[InifEC Error] : ProductService.getProductClassListLite request error.");
            console.error("status : " + status);
        });

        return factory.pdtClass["getProductClassListLite"].promise;
    }

    // --------------------------------
    // 取得所有商品分類
    // --------------------------------
    var getProductByPdtClass = function(pdtclass) {

        var params = {
                op: "getPdtListByClass",
                pdtclass: pdtclass
            },
            cachekey = JSON.stringify(params);

        if(factory.listCache[cachekey]) {
            return factory.listCache[cachekey].promise;
        }

        factory.listCache[cachekey] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ProductAction.do",
            method: "GET",
            params: params,
            withCredentials: true
        }).success(function(data){
            if(data.error){

                factory.listCache[cachekey].reject(data.error);
            } else {
                factory.listCache[cachekey].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.listCache[cachekey].reject(data);
            factory.listCache[cachekey] = undefined;
            console.error("[InifEC Error] : ProductService.getProductByPdtClass request error.");
            console.error("status : " + status);
        });

        return factory.listCache[cachekey].promise;

    }

    // --------------------------------
    // 取得所有商品詳細資訊
    // --------------------------------
    var getProductInfo = function(productid) {

        var params = {
                op: "getPdtInfo",
                productid: productid
            },
            cachekey = JSON.stringify(params);

        if(factory.pdtCache[cachekey]) {
            return factory.pdtCache[cachekey].promise;
        }

        factory.pdtCache[cachekey] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ProductAction.do",
            method: "GET",
            params: params,
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.pdtCache[cachekey].reject(data.error);
            } else {
                factory.pdtCache[cachekey].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.pdtCache[cachekey].reject(data);
            factory.pdtCache[cachekey] = undefined;
            console.error("[InifEC Error] : ProductService.getProductInfo request error.");
            console.error("status : " + status);
        });

        return factory.pdtCache[cachekey].promise;

    }

    // --------------------------------
    // 搜尋商品
    // --------------------------------
    var searchProduct = function(keyword, start, len) {

        var params = {
                op: "searchPdt",
                keyword: keyword,
                start: start,
                len: len
            },
            cachekey = JSON.stringify(params);

        if(factory.pdtCache[cachekey]) {
            return factory.pdtCache[cachekey].promise;
        }

        factory.pdtCache[cachekey] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ProductAction.do",
            method: "GET",
            params: params,
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.pdtCache[cachekey].reject(data.error);
            } else {
                factory.pdtCache[cachekey].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.pdtCache[cachekey].reject(data);
            factory.pdtCache[cachekey] = undefined;
            console.error("[InifEC Error] : ProductService.getProductInfo request error.");
            console.error("status : " + status);
        });

        return factory.pdtCache[cachekey].promise;
    }

    // --------------------------------
    // 取得複合商品Map
    // --------------------------------
    var getComplexPdtMap = function() {

        var params = {
                op: "getComplexPdtMap",
            },
            cachekey = JSON.stringify(params);

        if(factory.pdtCache[cachekey]) {
            return factory.pdtCache[cachekey].promise;
        }

        factory.pdtCache[cachekey] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ProductAction.do",
            method: "GET",
            params: params,
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.pdtCache[cachekey].reject(data.error);
            } else {
                factory.pdtCache[cachekey].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.pdtCache[cachekey].reject(data);
            factory.pdtCache[cachekey] = undefined;
            console.error("[InifEC Error] : ProductService.getComplexPdtMap request error.");
            console.error("status : " + status);
        });

        return factory.pdtCache[cachekey].promise;
    }

    /*==========================
        Members
    ==========================*/
    // 商品分類
    factory.pdtClass = {};
    // 商品列表cache
    factory.listCache = {};
    // 商品cache
    factory.pdtCache = {};

    /*==========================
        Methods
    ==========================*/
    /** 取得全站商品大分類、分類（完整版） */
    factory.getPdtClassList = getPdtClassList;
    /** 取得全站商品大分類、分類（精簡版） */
    factory.getProductClassListLite = getProductClassListLite;
    /* 取得所有商品分類 */
    factory.getProductByPdtClass = getProductByPdtClass;
    /** 取得所有商品詳細資訊 */
    factory.getProductInfo = getProductInfo;
    /** 搜尋商品 */
    factory.searchProduct = searchProduct;
    // 取得複合商品Map
    factory.getComplexPdtMap = getComplexPdtMap;

    return factory;
}]);